export const East = (props: any) => <svg {...props} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="EastIcon">
  <path d="m15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7z"></path>
</svg>